import { MappedSchoolParams } from '#server/models';
import { Input, NumberInput } from '@/components/ui';
import { HDRData } from './ModifySchoolParameters';

interface HDRParamsProps {
  hdrData: HDRData;
  handleOnChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const HDRParams = ({ hdrData, handleOnChange }: HDRParamsProps) => {
  return (
    <>
      <h3 className="text-sh3 font-bold text-primary-black-90">HDR</h3>
      <dl className="grid grid-cols-[max-content_1fr] items-center gap-x-5 gap-y-3 text-b2 text-secondary-grey-02 [grid-auto-rows:75px]">
        <dt className="font-bold">HDR supervision allowance</dt>
        <dd className="flex items-center gap-2">
          <NumberInput
            className="h-[30px] w-[117px] border-secondary-grey-04 text-b2"
            min={0}
            value={hdrData.hdrSupervisorAllowance}
            data-category="hdr"
            data-key="hdrSupervisorAllowance"
            onChange={handleOnChange}
          />
        </dd>

        <dt className="font-bold">HDR thesis chair allowance</dt>
        <dd className="flex items-center gap-2">
          <NumberInput
            className="h-[30px] w-[117px] border-secondary-grey-04 text-b2"
            min={0}
            value={hdrData.hdrThesisChairAllowance}
            data-category="hdr"
            data-key="hdrThesisChairAllowance"
            onChange={handleOnChange}
          />
        </dd>
      </dl>
    </>
  );
};
